var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 17.536 17.536 5 33 5C48.464 5 61 17.536 61 33C61 48.464 48.464 61 33 61C17.536 61 5 48.464 5 33Z",
    fill: "#F4EBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0833 27.7497L41.1666 23.6663M43.5 21.333L41.1666 23.6663L43.5 21.333ZM32.2883 32.5447C32.8907 33.1391 33.3696 33.8467 33.6973 34.6269C34.0251 35.4071 34.1953 36.2445 34.1982 37.0907C34.201 37.937 34.0364 38.7755 33.7139 39.5579C33.3913 40.3402 32.9172 41.0511 32.3188 41.6495C31.7204 42.2479 31.0095 42.722 30.2271 43.0446C29.4448 43.3671 28.6063 43.5317 27.76 43.5289C26.9138 43.526 26.0764 43.3558 25.2962 43.0281C24.516 42.7003 23.8083 42.2214 23.214 41.619C22.0451 40.4088 21.3983 38.7879 21.413 37.1055C21.4276 35.4231 22.1024 33.8137 23.2921 32.624C24.4818 31.4343 26.0912 30.7595 27.7736 30.7448C29.4561 30.7302 31.0769 31.377 32.2871 32.5458L32.2883 32.5447ZM32.2883 32.5447L37.0833 27.7497L32.2883 32.5447ZM37.0833 27.7497L40.5833 31.2497L44.6666 27.1663L41.1666 23.6663L37.0833 27.7497Z",
    stroke: "#7F56D9",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56C20.2975 56 10 45.7025 10 33H0C0 51.2254 14.7746 66 33 66V56ZM56 33C56 45.7025 45.7025 56 33 56V66C51.2254 66 66 51.2254 66 33H56ZM33 10C45.7025 10 56 20.2975 56 33H66C66 14.7746 51.2254 0 33 0V10ZM33 0C14.7746 0 0 14.7746 0 33H10C10 20.2975 20.2975 10 33 10V0Z",
    fill: "#F9F5FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.445dad8d.svg";
export { ForwardRef as ReactComponent };